import { ShellSkin } from './skin-storage';

export const LOGO_PADRAO = 'assets/img/logo.png';
export const LOGO_PADRAO_REDUZIDO = 'assets/img/logo_min.png';

/** http(s) → como está; senão prefixa data:image/jpg;base64, (regra do FullLayout/SidebarComponent). */
export function encodeLogo(value: string): string {
  return value.startsWith('http') ? value : `data:image/jpg;base64,${value}`;
}

/** http(s) → como está; senão prefixa data:image/x-icon;base64, (regra do login-page). */
export function encodeFavicon(value: string): string {
  return value.startsWith('http') ? value : `data:image/x-icon;base64,${value}`;
}

// "undefined" como string é o sentinela de ausência gravado pelo login legado
// (sessionStorage.setItem com valor undefined vira a string "undefined").
function isAbsent(value: string | null): boolean {
  return !value || value === 'undefined';
}

/** Resolve logoHeader/logoHeaderReduzido aplicando encoding, com default nos sentinelas de ausência. */
export function resolveLogos(skin: ShellSkin): { logoHeader: string; logoHeaderReduzido: string } {
  return {
    logoHeader: isAbsent(skin.logoHeader) ? LOGO_PADRAO : encodeLogo(skin.logoHeader as string),
    logoHeaderReduzido: isAbsent(skin.logoHeaderReduzido)
      ? LOGO_PADRAO_REDUZIDO
      : encodeLogo(skin.logoHeaderReduzido as string),
  };
}
